import _ from 'lodash';
import Element from '../ui/Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';
import * as members from '../privates/privateMembers';
import menuUtils from '../privates/utils/menuUtils';
import {validate} from '../privates/validations/validation';


/**
 * @class VerticalMenu
 * @summary A vertical site menu.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @queryable
 * @tagname VerticalMenu
 * @viewername wysiwyg.common.components.verticalmenu.viewer.VerticalMenu
 * @definitionId wysiwyg.common.components.verticalmenu.viewer.VerticalMenu
 */
class VerticalMenu extends Element {

    set items(menuItems) {
        const RMI = members._RMI.get(this);
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'items',
            dataToValidate: {menuItems},
            compName: this.id
        })) {
            return this;
        }
        if (_.isNil(menuItems)){
            menuItems = [];
        }
        menuUtils.checkMenuItemsValidation({
            menuItems,
            functionName: 'items',
            compName: this.id
        });
        const convertedMenuItems = _.map(menuItems, (menuItem, menuItemIndex) => {
            return menuUtils.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'items');
        });
        RMI.setData(members._compId.get(this), {menuRef: {items: convertedMenuItems}});
    }

    get items() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const data = RMI.getFullDataWithOverrides(compId);
        const menuItems = data.menuRef.items;
        return _.map(menuItems, menuUtils.convertMenuItemToUserFormat);
    }
}

mixin(VerticalMenu.prototype, HiddenCollapsedMixin.prototype);

export default VerticalMenu;
